import { get, writable } from 'svelte/store';
import '../../app.logic';
import '../../services/activity.service';
import '../../services/company.service';
import { CompanyInvoiceService } from '../../services/companyinvoice.service';
import '../../services/contact.service';
import '../../utils/CustomFieldEntities/custom-field-utils';
import moment from "moment";
import { ClassificationService } from '../../services/classification.service';
import { ReportsService } from '../../services/reports.service';
export const loading = writable(false);
export const loading_invoicesemails = writable(false);
export const filter = writable({ criteria: {} });
export const companyInvoicesEmails = writable([]);
export const filter_invoiceemails = writable({ criteria: {} });
export const pagination_invoicesemails = writable(null);
export const records = writable([]);
export const record = writable(null);
export const recordData = writable(null);
export const ownerships = writable([]);
export async function initList() {
    await resetSearchFilter();
    filter_invoiceemails.set({ criteria: {}, params: null, sorting: "" });
    pagination_invoicesemails.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    recordData.set(null);
    await load();
}
export async function search() {
    await load();
}
export async function clearSearch() {
    await resetSearchFilter();
    search();
}
export async function resetSearchFilter() {
    let dateto = moment(Date.now()).local().toDate();
    //let datefrom = moment(Date.now()).local().subtract(3, 'M').toDate();
    let values = await ClassificationService.searchValueCombo('STATSOLLEC', 0, '').toPromise();
    let stati = [];
    values.payload.forEach(v => {
        //if (v.label == "Si sollecito" || v.label == "In valutazione")
        stati.push(v.oid);
    });
    filter.set({ criteria: { dataScadenzaFrom: null,
            dataScadenzaTo: dateto, stati: stati }, params: null, sorting: "" });
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _resp = await CompanyInvoiceService.getCompanyInvoicePayments(_filter, false).toPromise();
        records.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
export async function loadWithUpdate() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _resp = await CompanyInvoiceService.getCompanyInvoicePayments(_filter, true).toPromise();
        records.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
export function onEdit(item) {
    record.set(item);
}
export async function save() {
    let _record = get(record);
    await CompanyInvoiceService.saveCompanyInvoicePayment(_record).toPromise();
    await load();
}
export async function sendEmails(pec, targets, cloneOfOid) {
    await CompanyInvoiceService.sendCompanyInvoicePaymentEmails(pec, targets, cloneOfOid).toPromise();
    await load();
}
export async function loadInvoicesEmails() {
    loading_invoicesemails.set(true);
    try {
        let _filter_invoice = get(filter_invoiceemails);
        let _pag = get(pagination_invoicesemails);
        let _resp = await CompanyInvoiceService.getCompanyInvoicePaymentsEmails(_filter_invoice, _pag.currentPage).toPromise();
        //let _resp = await CompanyService.getCompanies(_filter, _pag.currentPage).toPromise();
        companyInvoicesEmails.set(_resp.payload);
        pagination_invoicesemails.set(_resp.pagination);
    }
    finally {
        loading_invoicesemails.set(false);
    }
}
export async function searchInvoicesEmails() {
    pagination_invoicesemails.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await loadInvoicesEmails();
}
export async function clearsearchInvoicesEmails() {
    pagination_invoicesemails.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await loadInvoicesEmails();
}
export function onPageChangeInvoiceEmails(pageNumber) {
    pagination_invoicesemails.set(Object.assign(Object.assign({}, get(pagination_invoicesemails)), { currentPage: pageNumber }));
    loadInvoicesEmails();
}
export function onExport() {
    let _filter = get(filter);
    ReportsService.exportExcelInsoluti(_filter);
}
